// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './axios'
import './axios/router'
import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);
import promptBox from '@/components/promptBox';
Vue.use(promptBox);

import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'animate.css'

Vue.use(VueVideoPlayer)
// import './axios/router'
Vue.config.productionTip = false
Vue.prototype.equipment = function () {
  if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
      return 'mobile'
  }
  else {
      return 'pc'
  }
  
}
Vue.prototype.getCode = function (textObj) {
  var defaults = {
    search: '',
    replace: [],
    speed: 30,
    delay: 100
  }
  var bintext = function (length) {
    let str = 'LINKUNHAO876959730@QQCOM';
    let tmp = '',
      i = 0,
      l = str.length;
    for (i = 0; i < length; i++) {
      tmp += str.charAt(Math.floor(Math.random() * l));
    }
    return tmp;
  };
  var text = textObj.text;
  var position = 0;
  var indexOf = text.indexOf(defaults.search);
  var normal = text.substr(0, indexOf);
  var changer = text.substr(indexOf, text.length)
  defaults.replace.push(changer);
  defaults.replace.push(changer);
  var len = 0
  var interval = setInterval(function () {
    var $bintext = '';
    if (len < text.length) {
      len ++
    }
    if (position == indexOf) {

      $bintext = bintext(len);
      textObj.text = text.substr(0, normal.length)
      textObj.text = $bintext
      if ($bintext==text) {
        textObj.isTrue = true
        clearInterval(interval)
      }
    } else if (position > indexOf) {
      $bintext = bintext(len);
      textObj.text = changer.substring(changer.length - position, position - indexOf) +$bintext.substring(position, ($bintext.length))
      if (changer.substring(changer.length - position, position - indexOf) +$bintext.substring(position, ($bintext.length))==text) {
        textObj.isTrue = true
        clearInterval(interval)
      }
      // $this.delay(defaults.speed).find('span').html(
      //   changer.substring(0, position - indexOf) +
      //   $bintext.substring(position, ($bintext.length))
      // );

    } else if (position < indexOf) {

      $bintext = bintext(len);
      textObj.text = normal.substring(0, position) +$bintext.substring(position, ($bintext.length))
      if (normal.substring(0, position) +$bintext.substring(position, ($bintext.length))==text) {
        textObj.isTrue = true
        clearInterval(interval)
      }

    }

    if (position < text.length) {
      position++;
    }
  }, defaults.speed)
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js